import { types } from '../../../constants/ActionTypes'

const initialState = {
}

const operationModeMenu = (state = initialState, action) => {
  const { bid } = action
  switch (action.type) {
    case types.operationModeMenu.OPEN:
      return { ...state, [bid]: { ...state[bid], anchorEl: action.anchorEl } }
    case types.operationModeMenu.CLOSE:
      return { ...state, [bid]: { ...state[bid], anchorEl: null } }
    default:
      return state
  }
}

export default operationModeMenu



// WEBPACK FOOTER //
// ./src/reducers/Common/RenjuBoardCard/ModeListMenu.js